import { authHeaders, client } from '../../_shared/services/openapiClient';
import type { paths } from '../../../types/schema';

export type GetBettieBalancesResponse =
  paths['/api/v1/bettie_balances/me']['get']['responses'][200]['content']['application/json'];

export type GetBettieBalanceTransactionsResponse =
  paths['/api/v1/bettie_balances/transactions']['get']['responses'][200]['content']['application/json'];

export async function getBettieBalances(): Promise<GetBettieBalancesResponse> {
  const { data, error } = await client.GET('/api/v1/bettie_balances/me', {
    headers: authHeaders()
  });
  if (error) throw error;
  if (!data) throw new Error('Empty response when getting bettie balances');
  return data;
}

export async function getBettieBalanceTransactions({
  pageParam = 1
}: {
  pageParam?: number;
}): Promise<GetBettieBalanceTransactionsResponse> {
  const { data, error } = await client.GET('/api/v1/bettie_balances/transactions', {
    headers: authHeaders(),
    params: {
      query: {
        asset_type: 'bettie_point',
        page: pageParam,
        per_page: 10
      }
    }
  });
  if (error) throw error;
  if (!data) throw new Error('Empty response when getting bettie balance transactions');
  return data;
}